import { NodeViewWrapper } from '@tiptap/react';
import React from 'react';

import { WidgetComponent } from './MinswapWidgetComponent';

export const WidgetNodeView = ({ node }: { node: any }) => {
  const type = node.attrs?.type;
  const defaultAsset = node.attrs?.defaultAsset as string | undefined;

  if (!type || type !== 'MinswapWidget') {
    return null;
  }

  return (
    <NodeViewWrapper>
      <WidgetComponent type={type} defaultAsset={defaultAsset} />
    </NodeViewWrapper>
  );
};
